var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "grid-state-btn",
      class: { "div-vertical": _vm.vertical },
      staticStyle: { "padding-left": "10px" }
    },
    [
      _c(
        "el-button",
        {
          class: { "btn-vertical": _vm.vertical },
          attrs: { no: "saveState", size: "mini", type: "primary" },
          on: { click: _vm.saveState }
        },
        [_vm._v(" " + _vm._s(_vm.saveBtnStr) + " ")]
      ),
      _c(
        "el-button",
        {
          class: { "btn-vertical": _vm.vertical },
          attrs: { no: "resetState", size: "mini", type: "primary" },
          on: { click: _vm.resetState }
        },
        [_vm._v(" " + _vm._s(_vm.resetBtnStr) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }